import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Gleap from 'gleap';
import ErrorPage from '../error-page/error-page';

const Fallback = ({ resetErrorBoundary }) => (
  <ErrorPage onRetry={resetErrorBoundary} />
);

const handleError = (error, info) => {
  try {
    Gleap.sendSilentCrashReport(error?.message || 'Unknown error', 'HIGH', {
      stack: error?.stack || '',
      componentStack: info?.componentStack || '',
      route: typeof window !== 'undefined' ? window.location.pathname : '',
    });
  } catch (_) {
    // Gleap not initialized (anonymous crash) — fall through to console
  }
  console.error('[AppErrorBoundary]', error, info);
};

const AppErrorBoundary = ({ children }) => (
  <ErrorBoundary
    FallbackComponent={Fallback}
    onError={handleError}
    onReset={() => window.location.reload()}
  >
    {children}
  </ErrorBoundary>
);

export default AppErrorBoundary;
